export default __webpack_public_path__ + "static/media/flag-for-south-korea-svgrepo-com.df5d139c.svg";